/**
 * One Growth-tab section (requirements §6.3): a titled row of KPI tiles,
 * then whatever card(s) the section carries. Tiles sit inside the shared
 * `.stat-band .stat-cards` grid so they look like every other Income tile —
 * but unlike StatBand there is no band-level snapshot/period header, since
 * a Growth row mixes both kinds and each tile wears its own BandTag.
 */
const GrowthSection = ({ title, subtitle, tiles, children }) => (
  <section className="growth-section">
    <header className="growth-section__header">
      <h3>{title}</h3>
      {subtitle && <p>{subtitle}</p>}
    </header>
    {tiles && (
      <div className="stat-band">
        <div className="stat-cards">{tiles}</div>
      </div>
    )}
    {children}
  </section>
);

export default GrowthSection;
